import { Secondary, SvgIcon } from '@cinch-labs/design-system'
import { useSearchAlertsDrawer } from '../../../hooks'
import SearchAlertsDrawer from '../drawer'
import styles from './search-alerts-button.module.css'

export type LayoutAreas = 'basket' | 'header' | 'listings' | 'noresults'

export interface SearchAlertsButtonProps {
  searchLayoutArea?: LayoutAreas
}

const SearchAlertsButton = ({
  searchLayoutArea = 'basket',
}: SearchAlertsButtonProps) => {
  const {
    handleSearchAlertsDrawerClick,
    showSearchAlertsDrawer,
    closeSearchAlertsDrawer,
  } = useSearchAlertsDrawer(searchLayoutArea)

  const buttonStyles = {
    basket: styles.filterBasketSearchAlertButton,
    header: styles.filterHeaderSearchAlertButton,
    listings: styles.filterListingSearchAlertButton,
    noresults: styles.filterListingSearchAlertButton,
  }

  return (
    <>
      <Secondary
        type="button"
        classNames={{
          button: buttonStyles[searchLayoutArea],
        }}
        onClick={handleSearchAlertsDrawerClick}
        data-cy="search-alerts-cta"
      >
        <SvgIcon
          name="mail"
          size={16}
          id="search-alert-icon"
          className={styles.filterSearchAlertButtonIcon}
        />
        Set up search alert
      </Secondary>

      {showSearchAlertsDrawer && (
        <SearchAlertsDrawer onClose={closeSearchAlertsDrawer} />
      )}
    </>
  )
}

export default SearchAlertsButton
